import { Howl } from 'howler';

import soundSuccess from '../resources/sounds/success.mp3';
import soundError from '../resources/sounds/error.mp3';
import soundInfo from '../resources/sounds/info.mp3';
import { getLocalSettingsSounds } from './local-settings';

const twitterSuccess = new Howl({
  src: [soundSuccess],
});

const twitterError = new Howl({
  src: [soundError],
});

const twitterInfo = new Howl({
  src: [soundInfo],
});

const playSoundIfEnabled = (type, theSound) => {
  const soundsStatus = getLocalSettingsSounds();

  if (type && soundsStatus[type]) {
    theSound.play();
  }
};

export const soundPlay = ({ type = '' }) => {
  if (type === 'success') {
    playSoundIfEnabled(type, twitterSuccess);
  } else if (type === 'error') {
    playSoundIfEnabled(type, twitterError);
  } else if (type === 'info') {
    playSoundIfEnabled(type, twitterInfo);
  } else {
    console.log(`This is :${type} sound`);
  }
};
